import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import DescriptionIcon from '@mui/icons-material/Description';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Typography } from "@mui/material";

import Question from '../../components/Question';
import InfoCard from "../../components/InfoCard";
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";

export default function AppointmentThankYou(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(userReset());
        dispatch(insuranceReset());
        dispatch(stripeReset());
    }, [dispatch]);

    return (
        <Question
            noBack={true}
            backgroundColor="#82B1FF33"
            componentHeight="100vh"
            title="Your follow-up appointment is confirmed."
            input={
                <>
                    <Typography variant="h6" fontWeight={400} mt={2} mb={1}>
                        What to Expect Next
                    </Typography>

                    <InfoCard
                        icon={DescriptionIcon}
                        title="Your Pre-Visit Check-in Form"
                        description="We will send you a link to complete a short form one week before your appointment. Completing this in advance is crucial as it allows your provider to review your progress before your visit, ensuring your time together is as focused and valuable as possible."
                    />

                    <InfoCard
                        icon={NotificationsActiveIcon}
                        title="Appointment Reminders"
                        description={
                            <>
                                We know life is busy, so we'll send you a reminder via SMS and email{" "}
                                <strong>24 hours</strong> before your appointment, and a final reminder{" "}
                                <strong>15 minutes</strong> before it's time to join your video visit.
                            </>
                        } />
                </>
            }
            {...props}
        />
    );
}
